@for (group of field.fieldGroup; track group.key; let i = $index; let last = $last) {
	<div class="form-row">
		<div class="gwc-multiple__item">
			<formly-field class="col" [field]="group"></formly-field>
			@if (formControl.value.length > 1) {
			<button mat-icon-button
				type="button"
				class="gwc-multiple__item-remove"
				(click)="remove(i)">
					<svg>
						<use href="assets/svg/shared.svg#close" />
					</svg>
				</button>
			}
		</div>
	</div>
}
<button mat-button
	color="primary"
	class="gwc-multiple__btn"
	(click)="add()"
	type="button">
	<div class="gwc-multiple__btn-label">
		<span class="gwc-multiple__btn-icon">+</span>
		Add
	</div>
</button>
